module.exports = __webpack_public_path__ + "static/media/daily-time-limit-image.b167128b.png";